/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Delete_WarningInputs */



/**
* | output |
* | --- |
* | "Only members without a VEKN ID can be deleted, and this can't be undone from the app." |
*
* @param {Member_Delete_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_delete_warning = /** @type {((inputs?: Member_Delete_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Delete_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les membres sans VEKN ID peuvent être supprimés, et cette action est irréversible depuis l'application.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo se pueden eliminar los miembros sin ID VEKN, y esta acción no se puede deshacer desde la aplicación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente membros sem VEKN ID podem ser excluídos, e essa ação não pode ser desfeita pelo aplicativo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo i membri senza VEKN ID possono essere eliminati e questa azione non può essere annullata dall'app.")
	return /** @type {LocalizedString} */ ("Only members without a VEKN ID can be deleted, and this can't be undone from the app.")
});